import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSwingSpeed = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 73.551,
	height: 34.802,
	viewBox: "0 0 73.551 34.802",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsxs("g", {
		id: "Group_126",
		"data-name": "Group 126",
		transform: "translate(0.5 0.5)",
		children: [
			/* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_32",
				"data-name": "Rectangle 32",
				width: 72.551,
				height: 33.802,
				fill: "none",
				stroke: "#040505",
				strokeWidth: 1,
				opacity: 0
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_264",
				"data-name": "Path 264",
				d: "M217.391,490.353",
				transform: "translate(-209.11 -475.16)",
				fill: "none",
				stroke: "#040505",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 4
			}),
			/* @__PURE__ */ _jsxs("g", {
				id: "Group_125",
				"data-name": "Group 125",
				transform: "translate(8.011 1.18)",
				children: [
					/* @__PURE__ */ _jsx("path", {
						id: "Path_265",
						"data-name": "Path 265",
						d: "M249.579,482.415c-.357-.163-.771-.343-1.212-.536a22.945,22.945,0,0,1-4.752-2.472c-1.165-1.137-3.976-4.661-5.13-6.123a1.253,1.253,0,0,0-.611-.417c.053-.242.116-.5.2-.772.571-1.782,2.029-6.172,2.03-6.172a1.056,1.056,0,0,0-2-.666c-.014.044-1.469,4.423-2.035,6.194a9.474,9.474,0,0,0-.486,3.105l-.047.089a3.347,3.347,0,0,1-2-.37,4.342,4.342,0,0,1-1.208-1.291c-.025-.039-.059-.07-.086-.107.18-.339.395-.776.675-1.347a30.523,30.523,0,0,0,1.675-6.514,1.056,1.056,0,1,0-2.088-.318,28,28,0,0,1-1.483,5.9c-.365.744-.585,1.169-.715,1.408a2.142,2.142,0,0,0-1.237.553,10.436,10.436,0,0,0-1.307,1.493,19.207,19.207,0,0,0-1.884,3.128c-.225.116-.607.423-1.617,1.729a1.055,1.055,0,0,0-.168.974,6.57,6.57,0,0,0,3.894,3.6c2.728,1.154,11.869,3.974,12.3,4.107a20.622,20.622,0,0,0,4.643.592,9.215,9.215,0,0,0,3.291-.518c1.683-.659,2.708-1.819,2.743-3.1A2.277,2.277,0,0,0,249.579,482.415Zm-18.659-10.523a1.044,1.044,0,0,0-.332.068A1.043,1.043,0,0,1,230.919,471.892Zm16.525,13.81c-1.976.774-5.458.154-6.587-.138-.094-.029-9.425-2.908-12.055-4.02a5.461,5.461,0,0,1-2.46-1.864c.231-.28.441-.52.557-.636l.147-.058a1.059,1.059,0,0,0,.6-.594,15.818,15.818,0,0,1,1.813-3.087,7.408,7.408,0,0,1,1.063-1.2c.015,0,.02.008.021.01h0a6.272,6.272,0,0,0,1.839,1.928,5.773,5.773,0,0,0,4.1.589,1.056,1.056,0,0,0,.721-.592c.09-.2.2-.406.3-.6,1.5,1.882,3.6,4.456,4.634,5.47.932.91,2.9,1.812,5.381,2.9.431.188.834.365,1.184.523.144.066.143.132.141.171C248.839,484.77,248.46,485.3,247.444,485.7Z",
						transform: "translate(-220.258 -463.803)",
						fill: "#101820"
					}),
					/* @__PURE__ */ _jsxs("g", {
						id: "Group_121",
						"data-name": "Group 121",
						transform: "translate(0 28.001)",
						children: [
							/* @__PURE__ */ _jsx("g", {
								id: "Group_118",
								"data-name": "Group 118",
								transform: "translate(26.347)",
								children: /* @__PURE__ */ _jsx("path", {
									id: "Path_266",
									"data-name": "Path 266",
									d: "M271.02,518.963h-3.167a1.056,1.056,0,1,1,0-2.111h3.167a1.056,1.056,0,0,1,0,2.111Z",
									transform: "translate(-266.797 -516.852)",
									fill: "#101820"
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								id: "Group_119",
								"data-name": "Group 119",
								transform: "translate(10.893)",
								children: /* @__PURE__ */ _jsx("path", {
									id: "Path_267",
									"data-name": "Path 267",
									d: "M246.3,518.963h-7.727a1.056,1.056,0,1,1,0-2.111H246.3a1.056,1.056,0,1,1,0,2.111Z",
									transform: "translate(-237.519 -516.852)",
									fill: "#101820"
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								id: "Group_120",
								"data-name": "Group 120",
								children: /* @__PURE__ */ _jsx("path", {
									id: "Path_268",
									"data-name": "Path 268",
									d: "M221.1,518.963h-3.167a1.056,1.056,0,0,1,0-2.111H221.1a1.056,1.056,0,0,1,0,2.111Z",
									transform: "translate(-216.881 -516.852)",
									fill: "#101820"
								})
							})
						]
					}),
					/* @__PURE__ */ _jsxs("g", {
						id: "Group_124",
						"data-name": "Group 124",
						transform: "translate(35.013 5.224)",
						children: [/* @__PURE__ */ _jsx("g", {
							id: "Group_122",
							"data-name": "Group 122",
							children: /* @__PURE__ */ _jsx("path", {
								id: "Path_269",
								"data-name": "Path 269",
								d: "M298.435,477.683v-1.757a2.228,2.228,0,0,0-2.225-2.225h-2.883a2.228,2.228,0,0,0-2.225,2.225v1.751a8.931,8.931,0,0,0-1.363.762,1.056,1.056,0,0,0,1.194,1.742,6.8,6.8,0,1,1-2.866,6.681l1.08,1.081a1.056,1.056,0,0,0,1.493-1.493l-2.811-2.811a1.055,1.055,0,0,0-1.493,0l-2.811,2.811a1.056,1.056,0,1,0,1.493,1.493l.938-.938a8.9,8.9,0,1,0,12.48-9.32Zm-5.222-.658v-1.1a.114.114,0,0,1,.114-.114h2.883a.114.114,0,0,1,.114.114v1.1a8.551,8.551,0,0,0-3.111,0Z",
								transform: "translate(-283.215 -473.701)",
								fill: "#101820"
							})
						}), /* @__PURE__ */ _jsx("g", {
							id: "Group_123",
							"data-name": "Group 123",
							transform: "translate(10.498 6.324)",
							children: /* @__PURE__ */ _jsx("path", {
								id: "Path_270",
								"data-name": "Path 270",
								d: "M304.16,485.683a1.056,1.056,0,0,0-1.056,1.056v4.708a1.056,1.056,0,0,0,.309.747l2.534,2.534a1.056,1.056,0,1,0,1.493-1.493l-2.224-2.225v-4.271A1.056,1.056,0,0,0,304.16,485.683Z",
								transform: "translate(-303.104 -485.683)",
								fill: "#101820"
							})
						})]
					})
				]
			})
		]
	})]
});
const ForwardRef = forwardRef(SvgSwingSpeed);
export { ForwardRef as ReactComponent };
